// ##### 23-09-29 Komarov: конфиг для указания email менеджеров, которым бдует отправляться почта с форм Партнёрство, Групповой запрос, Refugee Details Form
const managersEmails = [
  process.env.REACT_APP_MANAGERS_EMAIL,
  'san4os2008@gmail.com',
];

export { managersEmails };
